<div class="onboarding-content">
  <div class="element-box">
    <div class="section-header">
      <h4 class="onboarding-title">
        <ng-template [ngIf]="!isEditTicket">{{ 'Events&Tickets.Tickets.AddTicket' | translate }}</ng-template>
        <ng-template [ngIf]="isEditTicket">{{ 'Events&Tickets.Tickets.EditTicket' | translate }}</ng-template>
      </h4>
    </div>
    <form [formGroup]="ticketFormGroup">
      <div class="alert alert-danger borderless w-100" *ngIf="error">{{ error }}</div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">{{ 'Events&Tickets.Common.TicketName' | translate }}</label>
            <input class="form-control" name="name" formControlName="name" type="text" value="" ngbAutofocus />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="">{{ 'Events&Tickets.Tickets.AdditionalText' | translate }} </label>
            <textarea
              class="form-control"
              name="additionalText"
              formControlName="additionalText"
              placeholder="Dieser Text wird nur auf das Ticket gedruckt."
              type="text"
              value=""
            ></textarea>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label for="">{{ 'Events&Tickets.Common.Description' | translate }}</label>
            <textarea
              class="form-control"
              name="description"
              formControlName="description"
              type="text"
              value=""
            ></textarea>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label class="w-100">{{ 'Events&Tickets.Tickets.Personalization' | translate }} </label>
            <mat-slide-toggle
              name="isTcktHldrNameCmplsr"
              formControlName="isTcktHldrNameCmplsr"
              [(ngModel)]="isTcktHldrNameCmplsr"
            >
              <div class="info">
                {{ 'Events&Tickets.Tickets.PerText' | translate }}
              </div>
            </mat-slide-toggle>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label for="">{{ 'Events&Tickets.Tickets.pdfUploadTitle' | translate }}</label>
            <input
              class="file-input form-control"
              style="display:none"
              type="file"
              name="templateFileURL"
              #fileInput
              (change)="onFilesSelected(fileInput.files)"
            />
            <div class="input-group">
              <div class="input-group-prepend">
                <button type="button" class="btn btn-secondary" (click)="fileInput.click()">
                  {{ 'Events&Tickets.Tickets.ChooseFile' | translate }}
                </button>
              </div>
              <input
                class="form-control"
                placeholder="{{ 'Events&Tickets.Tickets.NoFileSelected' | translate }}"
                [value]="fileName"
                readonly
              />
              <div class="input-group-append" *ngIf="fileName">
                <button
                  type="button"
                  class="btn btn-danger"
                  (click)="removeFile()"
                  matTooltip="{{ 'Events&Tickets.Tickets.RemoveFiles' | translate }}"
                >
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
            <!-- <small> {{ 'Events&Tickets.Tickets.AllowFileFormat' | translate }}</small> -->
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label for="">{{ 'Events&Tickets.Tickets.ServiceCharge' | translate }} (EUR) </label>
            <div class="w-25">
              <number-spinner
                name="serviceCharge"
                [min]="0.0"
                [max]="3.0"
                [step]="0.01"
                [precision]="0.01"
                [inputDisabled]="false"
                [defaultValue]="+ticketFormGroup.value.serviceCharge"
                (whenChange)="serviceChargeChanged($event)"
              ></number-spinner>
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group w-25">
            <label for="">{{ 'Events&Tickets.Tickets.MinimumPeople' | translate }} </label>
            <input class="form-control" name="minimumPeople" formControlName="minimumPeople" type="number" />
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group w-25">
            <label for="">{{ 'Events&Tickets.Tickets.TicketCount' | translate }}</label>
            <input class="form-control" name="amount" formControlName="amount" type="number" ngbAutofocus />
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label class="w-100">{{ 'Events&Tickets.Tickets.feeCalculation' | translate }} </label>
            <mat-slide-toggle name="feeTakeover" formControlName="feeTakeover" [(ngModel)]="feeTakeover">
              <div class="info">
                {{ 'Vouchers.Settings.GuestPayPayment' | translate }}
                <i
                  class="fa fa-info-circle details-icon"
                  title="{{ 'Vouchers.Settings.PaymentFeesInfo' | translate }}"
                ></i>
              </div>
            </mat-slide-toggle>
          </div>
          <div class="mat-info-banner mb-4 mr-4">
            <mat-icon class="info-icon">info</mat-icon>
            <span>
              {{ 'Events&Tickets.Tickets.feeTakeOverInfo' | translate }}
            </span>
          </div>
        </div>

        <div class="col-sm-6" *ngIf="isBVClient">
          <div class="form-group">
            <label class="w-100"> Use single ticket or connect res system</label>
            <mat-slide-toggle name="connectToResSystem" formControlName="connectToResSystem">
              <div class="info">
                Turn this on to connect with res system
              </div>
            </mat-slide-toggle>
          </div>
        </div>

        <div class="col-sm-6" *ngIf="ticketFormGroup.value.connectToResSystem">
          <div class="form-group">
            <label for="">Template</label>
            <ng-select
              [searchable]="false"
              [items]="shifts"
              [clearable]="false"
              formControlName="shiftId"
              bindLabel="name"
              bindValue="id"
              (change)="getRooms()"
            >
            </ng-select>
          </div>
        </div>
      </div>
      <div class="col-sm-6 mt-2" *ngIf="isVatInfo">
        <div class="section-header">
          <h4 class="onboarding-title">{{ 'Events&Tickets.VATInfo.vatTitle' | translate }}</h4>
        </div>
        <div class="mat-info-banner mb-3 mr-4">
          <mat-icon class="info-icon">info</mat-icon>
          <span>
            {{ 'Events&Tickets.Tickets.vatInfo' | translate }}
          </span>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>{{ vatInfo?.vat1 }}% {{ 'Events&Tickets.VATInfo.vat' | translate }}</label>
              <input
                type="number"
                formControlName="vat1"
                class="form-control"
                min="0"
                max="100"
                (input)="limitVatValue('vat1')"
                [ngClass]="{ 'error-border': showVatError('vat1') }"
              />
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label>{{ vatInfo?.vat2 }}% {{ 'Events&Tickets.VATInfo.vat' | translate }}</label>
              <input
                type="number"
                formControlName="vat2"
                class="form-control"
                min="0"
                max="100"
                (input)="limitVatValue('vat2')"
                [ngClass]="{ 'error-border': showVatError('vat2') }"
              />
            </div>
          </div>

          <div class="col-sm-4" *ngIf="isVATAllow">
            <div class="form-group">
              <label>{{ vatInfo?.vat3 }}% {{ 'Events&Tickets.VATInfo.vat' | translate }}</label>
              <input
                type="number"
                formControlName="vat3"
                class="form-control"
                min="0"
                max="100"
                (input)="limitVatValue('vat3')"
                [ngClass]="{ 'error-border': showVatError('vat3') }"
              />
            </div>
          </div>
        </div>
        <div class="counter">
          <span>{{ 'common.total' | translate }}:</span>&nbsp;
          <strong
            [ngClass]="{
              success: total === 100,
              error: total > 100
            }"
          >
            {{ total }}%
          </strong>
          <mat-chip [color]="progressColor" [class.chip-success]="total === 100" [selected]="true" class="status-chip">
            <mat-icon *ngIf="total === 100" class="chip-icon fw-bold">check_circle_outline</mat-icon>
            {{ chipLabel }}
          </mat-chip>
        </div>

        <mat-progress-bar [value]="total" [color]="progressColor" [class.progress-success]="total === 100">
        </mat-progress-bar>
      </div>
    </form>
  </div>

  <div class="element-box">
    <div class="section-header">
      <h4 class="onboarding-title">{{ 'Events&Tickets.Categories.Title' | translate }}</h4>
    </div>
    <div class="alert alert-outline-primary" style="background-color: #e1f0f7; border: 1px solid #5BC0DE;">
      <h5 style="color: #5BC0DE;">
        {{ 'Events&Tickets.Categories.WhatPriceCat' | translate }}
      </h5>
      <p>{{ 'Events&Tickets.Categories.PriceCatDes' | translate }}</p>
    </div>

    <div class="shifts price-category" *ngIf="allSubCategory && allSubCategory.length">
      <div style="color:red; padding-left: 10px;">{{ lastDeteleMessage }}</div>
      <ul class="form-list" cdkDropList (cdkDropListDropped)="dropTicket($event)">
        <li
          class="row sub-category-row"
          *ngFor="let eachData of allSubCategory; index as i"
          (cdkDropListDropped)="drop($event)"
          cdkDrag
        >
          <div class="col-sm-3 d-flex align-items-center">
            <button
              class="btn btn-white btn-link"
              cdkDragHandle
              matTooltip="Klicken und verschieben um Reihenfolge zu ändern"
              style="flex: 0 0 15%;margin-top: 12px;"
            >
              <i class="fas fa-sort"></i>
            </button>
            <div class="form-group" style="flex: 1;">
              <label for="">{{ 'Common.Name' | translate }}</label>
              <input
                class="form-control"
                [ngStyle]="{ 'border-color': i === 0 && ifNoCategory ? 'red' : '' }"
                type="text"
                [(ngModel)]="eachData.name"
                name="name{{ i + 1 }}"
              />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="">{{ 'Events&Tickets.Common.Description' | translate }}</label>
              <input
                class="form-control"
                type="text"
                name="description{{ i + 1 }}"
                [(ngModel)]="eachData.description"
              />
            </div>
          </div>
          <div class="col-sm-3" *ngIf="ticketFormGroup.value.connectToResSystem">
            <div class="form-group">
              <label for="">Rooms</label>
              <ng-select
                [searchable]="false"
                [items]="rooms"
                [clearable]="false"
                bindLabel="name"
                bindValue="id"
                name="roomId{{ i + 1 }}"
                [(ngModel)]="eachData.roomId"
              >
              </ng-select>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="">{{ 'Events&Tickets.Categories.StayTime' | translate }}</label>
              <input class="form-control" type="text" name="stayTime{{ i + 1 }}" [(ngModel)]="eachData.stayTime" />
            </div>
          </div>
          <div class="col-sm-1">
            <div class="form-group">
              <label for="">{{ 'Events&Tickets.Categories.GroupSize' | translate }}</label>
              <input class="form-control" type="text" name="groupSize{{ i + 1 }}" [(ngModel)]="eachData.groupSize" />
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label for="">{{ 'Events&Tickets.Common.Price' | translate }}</label>
              <input
                value="0"
                class="form-control"
                oninput="validity.valid||(value='')"
                name="price{{ i + 1 }}"
                [(ngModel)]="eachData.price"
                (focusout)="setToTwoDigits('subCategory', i)"
              />
            </div>
          </div>
          <div class="col-sm-1">
            <div class="form-group">
              <label for="">{{ 'Events&Tickets.Common.Actions' | translate }}</label>
              <button class="btn btn-danger delete-btn" (click)="removeCategory(eachData, i)" matTooltip="Löschen">
                <i class="far fa-trash-alt"></i>
              </button>
            </div>
          </div>
        </li>
      </ul>
      <button class="btn btn-primary" (click)="addSubCategory(isEditTicket)">
        <i class="fa fa-plus-circle fa-fw"></i> {{ 'Events&Tickets.Categories.AddPriceCat' | translate }}
      </button>
    </div>
  </div>
  <div class="element-box">
    <div class="section-header">
      <h4 class="onboarding-title">{{ 'Events&Tickets.Option.Title' | translate }}</h4>
    </div>
    <div class="alert alert-outline-primary" style="background-color: #e1f0f7; border: 1px solid #5BC0DE;">
      <h5 style="color: #5BC0DE;">
        {{ 'Events&Tickets.Option.AdditionalOpshead' | translate }}
      </h5>
      <p>{{ 'Events&Tickets.Option.AdditionalOpscont' | translate }}</p>
    </div>
    <div class="table-responsive shifts" *ngIf="allOptions && allOptions.length">
      <ul class="form-list">
        <li class="row mt-2" *ngFor="let eachData of allOptions; index as i">
          <div class="col-sm-6 col-lg-4">
            <div class="form-group">
              <label for="">{{ 'Common.Name' | translate }}</label>
              <input class="form-control" type="text" [(ngModel)]="eachData.name" name="name{{ i + 1 }}" />
            </div>
          </div>
          <div class="col-sm-6 col-lg-4">
            <div class="form-group">
              <label for="">{{ 'Events&Tickets.Common.Description' | translate }}</label>
              <input
                class="form-control"
                type="text"
                name="description{{ i + 1 }}"
                [(ngModel)]="eachData.description"
              />
            </div>
          </div>
          <div class="col-sm-6 col-lg-3">
            <div class="form-group">
              <label for="">{{ 'Events&Tickets.Common.Price' | translate }}</label>
              <input
                value="0"
                class="form-control"
                oninput="validity.valid||(value='')"
                name="price{{ i + 1 }}"
                [(ngModel)]="eachData.price"
                (focusout)="setToTwoDigits('option', i)"
              />
            </div>
          </div>
          <div class="col-sm-1">
            <div class="form-group">
              <label for="">{{ 'Events&Tickets.Common.Actions' | translate }}</label>
              <button class="btn btn-danger delete-btn" (click)="removeOption(eachData, i)" matTooltip="Löschen">
                <i class="far fa-trash-alt"></i>
              </button>
            </div>
          </div>
          <div class="container" *ngIf="isVatInfo">
            <div class="row">
              <div class="col-sm-6 col-lg-4">
                <div class="form-group">
                  <label>{{ vatInfo?.vat1 }}% {{ 'Events&Tickets.VATInfo.vat' | translate }}</label>
                  <input
                    name="price{{ i + 1 }}"
                    [(ngModel)]="eachData.vat1"
                    type="number"
                    class="form-control"
                    min="0"
                    max="100"
                    [ngClass]="{ 'error-border': !validateVatRow(eachData) }"
                  />
                </div>
              </div>

              <div class="col-sm-6 col-lg-4">
                <div class="form-group">
                  <label>{{ vatInfo?.vat2 }}% {{ 'Events&Tickets.VATInfo.vat' | translate }}</label>
                  <input
                    name="price{{ i + 1 }}"
                    [(ngModel)]="eachData.vat2"
                    type="number"
                    class="form-control"
                    min="0"
                    [ngClass]="{ 'error-border': !validateVatRow(eachData) }"
                  />
                </div>
              </div>

              <div class="col-sm-6 col-lg-3">
                <div class="form-group" *ngIf="isVATAllow">
                  <label>{{ vatInfo?.vat3 }}% {{ 'Events&Tickets.VATInfo.vat' | translate }}</label>
                  <input
                    name="price{{ i + 1 }}"
                    [(ngModel)]="eachData.vat3"
                    type="number"
                    class="form-control"
                    min="0"
                    [ngClass]="{ 'error-border': !validateVatRow(eachData) }"
                  />
                </div>
              </div>

              <div class="mt-1 ml-2" [ngClass]="isVatAllow ? 'col-sm-11' : 'col-sm-8'">
                <!-- {{ vatErrorMessage }}  *ngIf="!validateVatRow(eachData)" -->
                <div class="counter">
                  <span>{{ 'common.total' | translate }}:</span>&nbsp;
                  <strong
                    [ngClass]="{
                      success: validateVatRow(eachData).total === 100,
                      error: validateVatRow(eachData).total > 100
                    }"
                  >
                    {{ validateVatRow(eachData).total }}%
                  </strong>
                  <mat-chip
                    [color]="addonProgressColor(validateVatRow(eachData).total)"
                    [class.chip-success]="validateVatRow(eachData).total === 100"
                    [selected]="true"
                    class="status-chip"
                  >
                    <mat-icon *ngIf="validateVatRow(eachData).total === 100" class="chip-icon fw-bold"
                      >check_circle_outline</mat-icon
                    >
                    {{ addonchipLabel(validateVatRow(eachData).total) }}
                  </mat-chip>
                </div>

                <mat-progress-bar
                  [value]="validateVatRow(eachData).total"
                  [color]="addonProgressColor(validateVatRow(eachData).total)"
                  [class.progress-success]="validateVatRow(eachData).total === 100"
                >
                </mat-progress-bar>
              </div>
            </div>
            <hr />
          </div>
        </li>
      </ul>

      <!-- <table class="table table-padded">
        <thead>
          <tr>
            <th>name</th>
            <th>Beschreibung</th>
            <th style="text-align: right;">Preis</th>
            <th style="text-align: center;">Aktion</th>
          </tr>
        </thead>
        <tbody style="font-size: 14px;">
          <tr *ngFor="let eachData of allOptions; index as i">
            <th>
              <input class="form-control" type="text" [(ngModel)]="eachData.name" name="name{{ i + 1 }}" />
            </th>
            <th>
              <input
                class="form-control"
                type="text"
                name="description{{ i + 1 }}"
                [(ngModel)]="eachData.description"
              />
            </th>
            <th>
              <input
                type="number"
                style="text-align: right;"
                class="form-control"
                name="price{{ i + 1 }}"
                [(ngModel)]="eachData.price"
                (focusout)="setToTwoDigits('option', i)"
              />
            </th>
            <th style="text-align: center;">
              <-- <button
                class="btn btn-light"
                *ngIf="isEditTicket"
                (click)="updateOption(eachData)"
                matTooltip="Bearbeiten"
              >
                <i class="fas fa-edit"></i>
              </button> --
              <button class="btn btn-danger" (click)="removeOption(eachData, i)" matTooltip="Löschen">
                <i class="far fa-trash-alt"></i>
              </button>
            </th>
          </tr>
        </tbody>
      </table> -->
    </div>
    <button class="btn btn-primary" (click)="addOption(isEditTicket)">
      <i class="fa fa-plus-circle fa-fw"></i> {{ 'Events&Tickets.Option.AddOption' | translate }}
    </button>
  </div>
  <div class="clearfix">
    <button class="btn btn-primary" (click)="add()" *ngIf="!isEditTicket">
      {{ 'Events&Tickets.Tickets.AddTicket' | translate }}
    </button>
    <button class="btn btn-primary" (click)="save()" *ngIf="isEditTicket">
      {{ 'Events&Tickets.Tickets.UpdateTicket' | translate }}
    </button>
    <button class="btn btn-secondary" (click)="cancel()">
      {{ 'Common.Abort' | translate }}
    </button>
  </div>
</div>
